import React from "react";
import { AbstractDate } from "@linkfluence/models/date";
import { DatavizLineChart } from "@radarly/models/dataviz";
import { SearchFragmentDateMetrics } from "@radarly/models/search";
import { useFragmentsData } from "../../data";
import Loading from "../../loading";
import Inner from "./inner";

export interface SharedWidgetsMetricLineChartProps {
  project: number;
  fragment: SearchFragmentDateMetrics;
  evolutionFragment?: SearchFragmentDateMetrics;
  dataviz: DatavizLineChart;
  onClickPoint?: (
    uid: string | number,
    range: { from: Date; to: Date }
  ) => void;
  className?: string;
  forceReload?: boolean;
  disableAnimation?: boolean;
  nowDate?: AbstractDate;
  isFullscreen?: boolean;
  closeFullscreen?: () => void;
}

export default function SharedWidgetsMetricLineChart({
  project,
  fragment,
  evolutionFragment: comparaisonFragment,
  forceReload,
  isFullscreen,
  closeFullscreen,
  onClickPoint,
  ...props
}: SharedWidgetsMetricLineChartProps) {
  const { loading, data, comparaisonData } = useFragmentsData(
    project,
    fragment,
    comparaisonFragment
  );
  const _onClickPoint = (
    uid: string | number,
    range: { from: Date; to: Date }
  ) => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClickPoint(uid, range);
  };
  return (
    <Loading loading={loading} forceReload={forceReload}>
      <Inner
        data={data}
        fragment={fragment}
        comparaisonData={comparaisonData}
        comparaisonFragment={comparaisonFragment}
        loading={loading}
        isFullscreen={isFullscreen}
        onClickPoint={_onClickPoint}
        {...props}
      />
    </Loading>
  );
}
